import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";


const iNR_Content = [

    {
        format: bodyHelperTypes.title,
        order: 10,
        content: "Types of Peer support provided & work setting"
    },
    
    {
        format: bodyHelperTypes.paragraphs,
        order: 10,
        content: [

            <>
            New regulations go into effect on January 1, 2026 for peer support specialist depending on where you work and what services you provide.

            </>,

            <>
            <b>Certified Peer Support Specialists</b> provide peer support services in mental health, family services, youth services or substance use disorder (SUD) settings that are <u><b>NOT</b></u> licensed as an Alcohol & Other Drug Entity (AODE) or Behavioral Health Service Organization (BHSO), such as Recovery Community Centers, other community-based organizations, hospitals, or primary care clinics.  
            
            </>,

            <>
            For more information about Certified Peer Support Specialist requirements: <a href="https://tris.dbhdid.ky.gov/HelpFiles/PSS%20FAQ%20Updated-October%202023.pdf">Click Here</a>
            </>,

            <>
            <b>Registered Alcohol & Drug Peer Support Specialists</b> provide peer support services in substance use disorder (SUD) programs that ARE licensed as an Alcohol & Other Drug Entity (AODE) or Behavioral Health Service Organization (BHSO).     
            </>,

            <>
            For more information about becoming a Registered Alcohol & Drug Peer Support Specialist: <a href="https://adc.ky.gov/">Click Here</a>
            </>,

            
        ]
    },
    {
        format: bodyHelperTypes.title ,
        order: 20,
        content: "Take a look at the attached documents:"
    },
    {

        format: bodyHelperTypes.paragraphs,
        order: 30,
        content: [
            <>
            <ul>
                <li>Frequently Asked Questions to answer common questions</li>
                <li>Decision Tree Graphic to guide your next steps</li>
                <li>If you would like the attached documents in your primary language, please contact <a href="mailto:certifiedpeersupport@ky.gov ">certifiedpeersupport@ky.gov</a></li>
            </ul>
            </>
        ]
    },
    {
        format: bodyHelperTypes.title,
        order: 40,
        content: "What You Should Do?"
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 50,
        content: [
            <>
            <ul>
                <li>Be on the lookout for Informational/Q&A virtual sessions – coming soon! Session dates & times will be posted on the <a href="https://tris.dbhdid.ky.gov/">Tris website</a> and <a href="https://dbhdid.ky.gov/sud/ebpi-recovery">DBHDID website.</a></li>

                <li>If you need more information about the Registered Alcohol & Drug Peer Support Specialist, visit the <a  href="https://adc.ky.gov/Documents/ADC_RegisteredAlcoholandDrugPeerSupportSpecialistApplication.pdf">Kentucky Board of Alcohol & Drug Counselors website</a>. </li>

                <li>Don’t wait until the last minute – these changes take effect on January 1, 2026.  </li>

                <li>Have questions? Email <a href="certifiedpeersupport@ky.gov">certifiedpeersupport@ky.gov</a></li>
            </ul>
            </>
        ]
    }
    
]
export default iNR_Content;